import React, {ReactNode, useState} from 'react';
import {IViewContextMutateSingleVoyage} from "@containers/singleVoyage/mutateVoyage/context/viewContext/types";
import {ModeMutateSingleVoyage, ModeSecondaryMutateSidebarVoyage} from "@containers/singleVoyage/mutateVoyage/types";


export const MutateVoyageViewContext = React.createContext<IViewContextMutateSingleVoyage | null>(null)

interface IProps {
    children: ReactNode,
}

const ViewContextProviderMutateSingleVoyage = ({
                                                   children,

                                               }: IProps) => {

    const [miniModeRootSidebar, setMiniModeRootSidebar] = useState<boolean>(false)
    const [miniModeSecondarySidebar, setMiniModeSecondarySidebar] = useState<boolean>(false)

    const [mode, setMode] = useState<ModeMutateSingleVoyage>('points')
    const [modeSecondarySidebar, setModeSecondarySidebar] = useState<ModeSecondaryMutateSidebarVoyage>('hide')
    const [touchedEditRouteInfo, setTouchedEditRouteInfo] = useState<boolean>(false)

    return (
        <MutateVoyageViewContext.Provider
            value={{
                mode, setMode,
                modeSecondarySidebar,
                setModeSecondarySidebar,
                miniModeRootSidebar,
                setMiniModeRootSidebar,
                miniModeSecondarySidebar,
                setMiniModeSecondarySidebar,
                touchedEditRouteInfo,setTouchedEditRouteInfo
            }}
        >
            {children}
        </MutateVoyageViewContext.Provider>
    );
};

export default ViewContextProviderMutateSingleVoyage;